import assert from 'assert';

import {RowModelContext} from 'notebook/tables/store/contexts/RowModelContext';
import {RowModel} from 'notebook/tables/store/models/RowModel';

export function useRowModel(): RowModel;
export function useRowModel<T>(subSelector: (rowModel: RowModel) => T): T;
export function useRowModel<T>(subSelector?: (rowModel: RowModel) => T): T {
  const {rowModelSelector, useTableEditableStore} = RowModelContext.useContext();
  return useTableEditableStore((store) => {
    const rowModel = rowModelSelector(store);
    assert(rowModel, `RowModel not found`);
    if (!subSelector) {
      return rowModel as T;
    }
    return subSelector(rowModel);
  });
}
